import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { COLORS } from '../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../config/designSystem/typography';

interface LoadingProps {
  withLabel?: boolean;
  label?: string;
  color?: string;
}

const Loading = ({ withLabel, label, color }: LoadingProps) => {
  return (
    <View style={styles.activityIndicatorWrapper}>
      <ActivityIndicator size="large" color={color ? color : COLORS.brand[500]} />
      {withLabel && <ParagraphMRegular>{label}</ParagraphMRegular>}
    </View>
  );
};

const styles = StyleSheet.create({
  activityIndicatorWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    flex:1
  },
});

export default Loading;
